module.exports = __webpack_public_path__ + "d300b12f5feb181d596bc0d352f3acb5.MP3";